import { Component } from "react";
import HalCompassInitReport from "./HalCompassReport/HalCompassInitReport";
import moment from "moment";

class HalCompassReportList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedReportData: '',
            reportDataFormattedDate: '',
            reportDataFormattedTime: '',

            filterType: 'all', // 'all', 'company', or 'scheme'
            selectedCompany: '',
            selectedScheme: ''
        }
    }

    showReport = (selectedReportData, formattedDate, formattedTime) => {
        
        this.setState({
            selectedReportData: selectedReportData,
            reportDataFormattedDate: formattedDate,
            reportDataFormattedTime: formattedTime
        })
        document.getElementById('report-modal').style.display = "block";
    }

    hideReport = () => {
        document.getElementById('report-modal').style.display = "none";
    }

    // handleFilterTypeChange = (event) => {
    //     const filterType = event.target.value;
    //     this.setState({ 
    //         filterType: filterType,
    //         selectedCompany: '',
    //         selectedScheme: ''
    //     });
    // }

    getUniqueCompanies = () => {
        const { resultHalCompass } = this.props;
        if (!resultHalCompass) return [];

        const companies = resultHalCompass.map(report => ({
            id: report.companyProfile.companyId,
            name: report.companyProfile.name
        }));

        // Remove duplicates based on company name
        const uniqueCompanies = Array.from(
            new Map(companies.map(c => [c.name, c])).values()
        );

        return uniqueCompanies.sort((a, b) => a.name.localeCompare(b.name));
    }

    getUniqueSchemes = () => {
        const { resultHalCompass } = this.props;
        if (!resultHalCompass) return [];

        const schemes = resultHalCompass.map(report => ({
            id: report.selectedScheme.id || report.selectedScheme.name,
            name: report.selectedScheme.name
        }));

        // Remove duplicates based on scheme name
        const uniqueSchemes = Array.from(
            new Map(schemes.map(s => [s.name, s])).values()
        );

        return uniqueSchemes.sort((a, b) => a.name.localeCompare(b.name));
    }

    getFilteredReports = () => {
        const { resultHalCompass } = this.props;
        const { selectedCompany, selectedScheme} = this.state;

        if (!resultHalCompass) return [];

        let filtered = resultHalCompass;

        // Apply company filter
        if (selectedCompany) {
            filtered = filtered.filter(report =>
                report.companyProfile.name === selectedCompany
            );
        }

        // Apply scheme filter
        if (selectedScheme) {
            filtered = filtered.filter(report =>
                report.selectedScheme.name === selectedScheme
            );
        }

        return filtered;
    }

    clearFilters = () => {
        this.setState({
            selectedCompany: '',
            selectedScheme: ''
        });
    }

    render() {
        const { resultHalCompass, profile } = this.props;
        const { selectedReportData, reportDataFormattedDate, reportDataFormattedTime, selectedCompany, selectedScheme } = this.state;

        const filteredReports = this.getFilteredReports();
        const uniqueCompanies = this.getUniqueCompanies();
        const uniqueSchemes = this.getUniqueSchemes();

        return (
            <div>
                <div id="report-modal" className="mymodal">
                    <div className="mymodal-content col-md-6 d-flex flex-column">
                        <div>
                            <span className="close" onClick={this.hideReport}>&times;</span>
                        </div>
                        <div><HalCompassInitReport selectedReportData={selectedReportData} formattedDate={reportDataFormattedDate} formattedTime={reportDataFormattedTime} /></div>
                    </div>
                </div>

                {/* Filter Section */}
                <div className="mb-4">
                    <div className="row">
                        {/* <div className="col-md-3">
                            <label><b>Filter By</b></label>
                            <select className="form-control" value={filterType} onChange={this.handleFilterTypeChange}>
                                <option value="all">All Reports</option>
                                <option value="company">Company Name</option>
                                <option value="scheme">Selected Scheme</option>
                            </select>
                        </div> */}

                        {/* {filterType === 'company' && (
                            <div className="col-md-4">
                                <label><b>Select Company</b></label>
                                <select 
                                    className="form-control" 
                                    value={selectedCompany} 
                                    onChange={event => this.setState({ selectedCompany: event.target.value })}
                                >
                                    <option value="">-- Choose Company --</option>
                                    {uniqueCompanies.map((company, idx) => (
                                        <option key={idx} value={company.name}>
                                            {company.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )} */}
                        <div className="col-md-4">
                            <label><b>Select Company</b></label>
                            <select
                                className="form-control"
                                value={selectedCompany}
                                onChange={event => this.setState({ selectedCompany: event.target.value })}
                            >
                                <option value="">-- Choose Company --</option>
                                {uniqueCompanies.map((company, idx) => (
                                    <option key={idx} value={company.name}>
                                        {company.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* {filterType === 'scheme' && (
                            <div className="col-md-4">
                                <label><b>Select Scheme</b></label>
                                <select 
                                    className="form-control" 
                                    value={selectedScheme} 
                                    onChange={event => this.setState({ selectedScheme: event.target.value })}
                                >
                                    <option value="">-- Choose Scheme --</option>
                                    {uniqueSchemes.map((scheme, idx) => (
                                        <option key={idx} value={scheme.name}>
                                            {scheme.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )} */}
                        <div className="col-md-4">
                            <label><b>Select Scheme</b></label>
                            <select
                                className="form-control"
                                value={selectedScheme}
                                onChange={event => this.setState({ selectedScheme: event.target.value })}
                            >
                                <option value="">-- Choose Scheme --</option>
                                {uniqueSchemes.map((scheme, idx) => (
                                    <option key={idx} value={scheme.name}>
                                        {scheme.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* {filterType !== 'all' && (
                            <div className="col-md-2">
                                <label>&nbsp;</label>
                                <button 
                                    className="btn btn-secondary form-control" 
                                    onClick={this.clearFilters}
                                >
                                    Clear Filters
                                </button>
                            </div>
                        )} */}
                        <div className="col-md-2">
                            <label>&nbsp;</label>
                            <button
                                className="btn btn-secondary form-control"
                                onClick={this.clearFilters}
                            >
                                Clear Filters
                            </button>
                        </div>
                    </div>

                    {/* Display active filter info */}
                    {(selectedCompany || selectedScheme) && (
                        <div className="mt-2">
                            <small className="text-muted">
                                Showing {filteredReports.length} of {resultHalCompass?.length || 0} reports
                                {selectedCompany && ` (filtered by company: "${selectedCompany}")`}
                                {selectedScheme && ` (filtered by scheme: "${selectedScheme}")`}
                            </small>
                        </div>
                    )}
                </div>

                <div className="emp-list">
                    <div>
                        <table className="mt-5 table">
                            <thead>
                                <tr>
                                    <th scope="col">No.</th>
                                    <th>Company Name</th>
                                    <th>Selected Scheme</th>
                                    <th>Submission Date</th>
                                    <th>Score (%)</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredReports.length > 0 ? filteredReports.map((halcomp, halcompIndex) => {
                                    const date = halcomp.dateCreated;
                                    const formattedDate = date.substring(0, date.indexOf(" at")).trim();
                                    const formattedTime = date.substring(date.indexOf("at") + 3, date.indexOf(" UTC+8")).trim();
                                    return (
                                        <tr key={halcompIndex}>
                                            <td>{halcompIndex + 1}</td>
                                            <td>
                                                {halcomp.companyProfile.name}
                                            </td>
                                            <td>{halcomp.selectedScheme.name}</td>
                                            <td>{formattedDate}</td>
                                            <td>{halcomp.percentageScore !== undefined && halcomp.percentageScore !== null ? halcomp.percentageScore : 'No score'}</td>
                                            <td>
                                                {(moment().isAfter(moment(new Date(halcomp.dateExpired))) || moment().isSame(moment(new Date(halcomp.dateExpired)))) ? (
                                                    (profile.type !== "admin" ? (<div className="text-danger"><b>Expired</b></div>) : (
                                                        <button className="btn all-btn" style={{backgroundColor:'red', opacity:0.7}} onClick={() => this.showReport(halcomp, formattedDate, formattedTime)}><span><i className="fas fa-eye" />{' '}Expired</span></button>
                                                    ))
                                                ) : (
                                                    <button className="btn all-btn" onClick={() => this.showReport(halcomp, formattedDate, formattedTime)}><span><i className="fas fa-eye" />{' '}View</span></button>
                                                )}
                                            </td>
                                        </tr>)
                                }) : (
                                    <tr>
                                        <td colSpan="6" className="text-center">
                                            {resultHalCompass && resultHalCompass.length > 0
                                                ? 'No reports match your filter criteria'
                                                : 'No Data'}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        )
    }
}

export default HalCompassReportList